export default __webpack_public_path__ + "resources/icons/d242-91c6.png";